import { FormEmojiTextInput, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProtocolMessageInput } from "./ProtocolMessageInput";
import { TProtocolDefaultForm } from "./ProtocolDefaultSchema";
import { useWatch } from "react-hook-form";

const translationPath = "page.settings.crm.protocolsDefault.";

const ProtocolMessage = () => {
  const { control } = useFormContext<TProtocolDefaultForm>();
  const { t } = useTranslation();

  const automation = useWatch({
    name: "ticketAutomation",
    control,
  });

  return (
    <Grid item xs={12} sm={12} display={"flex"} alignItems={"start"}>
      <ProtocolMessageInput name="message" automationId={automation?.id} />
    </Grid>
  );
};

export default ProtocolMessage;
